import React, { useEffect, useState } from 'react';
import {
  Input, FormGroup, FormText, Label,
} from 'reactstrap';

const BackgroundImage = ({
  awsImage,
  setImage,
  title,
  width = 1280,
  height = 960,
}) => {
  const [errorImage, setErrorImage] = useState(null);

  useEffect(() => {
    onImagesUpload({
      target: {
        files: [
          awsImage,
        ],
      },
      isFromAws: true,
    });
  }, [awsImage]);

  const onImagesUpload = async ({ target: { files }, isFromAws = false }) => {
    if (!files[0]) {
      return;
    }

    const response = await fetch(files[0]);
    const data = await response.blob();

    setErrorImage(null);
    setImage(null);

    if (files[0].size > 2 ** 20) {
      setErrorImage('Uploaded image is more than 1 Mo.');
      return;
    }

    const reader = new FileReader();
    const image = new Image();

    image.crossOrigin = 'anonymous';

    image.onload = () => {
      if (image.height === height && image.width === width) {
        setImage(image.src);
      } else {
        setErrorImage("Uploaded image doesn't meet size requirements.");
      }
    };
    reader.onloadend = () => {
      image.src = reader.result;
    };
    reader.readAsDataURL(isFromAws ? data : files[0]);
  };

  return (
    <FormGroup>
      <Label for="channelDescription">
        {title}
      </Label>
      <Input type="file" name="background" accept="image/*" onChange={onImagesUpload} />
      <FormText color="muted">
        Uploaded image should be less than 1 Mo and sized
        {width}
        x
        {height}
      </FormText>
      {errorImage && (
        <FormText color="danger">
          {errorImage}
        </FormText>
      )}
    </FormGroup>
  );
};

export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/components/channels/backgroundImage.js